import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

/**
 * Service to get Plo6 game tables only
 */
export const getPlo6GameTablesService = (data) => {
  return axiosInstanceService(METHOD_TYPES.get, 'poker/get-all-game-tables', {}, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.page,
    params: data
  })
}

/**
 * Service to take seat in Plo6 game
 * @param {object} data - object contains { tableId, seatNumber, buyInAmount, gameType: 'Plo6' }
 */
export const takePlo6SeatService = (data) => {
  const Plo6Data = {
    ...data,
    gameType: 'plo6'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-seat', Plo6Data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to take Plo6 game action (call, bet, raise, check, fold)
 * @param {object} data - object contains { tableId, roundId, action, betAmount?, gameType: 'Plo6' }
 */
export const takePlo6ActionService = (data) => {
  const Plo6Data = {
    ...data,
    gameType: 'plo6'
  }

  return axiosInstanceService(METHOD_TYPES.post, 'poker/take-action', Plo6Data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo6 player sitting status (direct sit-out/return)
 * @param {object} data - object contains { tableId, sittingOut, sitOutType?, gameType: 'Plo6' }
 */
export const updatePlo6PlayerSittingStatusService = (data) => {
  const payload = {
    tableId: data.tableId,
    sittingOut: data.sittingOut,
    gameType: 'plo6'
  }
  if (data.sittingOut && data.sitOutType) {
    payload.sitOutType = data.sitOutType
  }
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sitting-status', payload, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo6 player "Sit Out Next BB" flag
 * @param {object} data - object contains { tableId, sitOutNextBB, gameType: 'Plo6' }
 */
export const updatePlo6PlayerSitOutNextBBService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-player-sit-out-next-bb', {
    tableId: data.tableId,
    sitOutNextBB: data.sitOutNextBB,
    gameType: 'plo6'
  }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to update Plo6 buy-in amount
 * @param {object} data - object contains { tableId, newAmount, gameType: 'Plo6' }
 */
export const updatePlo6BuyInAmountService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/update-buyIn-amount', { ...data }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to change seat in Plo6 game
 * @param {object} data - object contains { tableId, fromSeat, toSeat, gameType: 'Plo6' }
 */
export const changePlo6SeatService = (data) => {
  return axiosInstanceService(METHOD_TYPES.put, 'poker/change-seat', { ...data, gameType: 'plo6' }, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}

/**
 * Service to submit run it twice decision
 * @param {object} data - object contains { tableId, roundId, decision: 'ACCEPTED' | 'DECLINED' }
 */
export const runItTwiceDecisionService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'poker/run-it-twice/decision', data, {
    server: microServices.SERVICE_URL_1,
    loader: LOADER_HANDLER_TYPES.submit
  })
}
